import { render, staticRenderFns } from "./codeverify.vue?vue&type=template&id=61950321&scoped=true"
import script from "./codeverify.vue?vue&type=script&lang=js"
export * from "./codeverify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61950321",
  null
  
)

export default component.exports